// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureToggleService } from '@coa/app/shared/feature-toggle/services/feature-toggle.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleGuard implements CanActivate {
  constructor(
    private featureToggleService: FeatureToggleService,
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.featureToggleService.isFeatureAdded(route.data['featureToggle'], route.params.clientId).pipe(
      tap(isEnabled => {
        if (!isEnabled) {
          this.router.navigate(['./page-not-found']);
        }
      }),
    );
  }

}
